import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface INotification {
  type: 'success' | 'error' | 'info';
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private notificationSubject = new BehaviorSubject<INotification | null>(null);
  notification$ = this.notificationSubject.asObservable();

  showSuccess(message: string) {
    this.notificationSubject.next({ type: 'success', message });
    this.clearAfterDelay();
  }

  showError(message: string) {
    this.notificationSubject.next({ type: 'error', message });
    this.clearAfterDelay();
  }

  showInfo(message: string) {
    this.notificationSubject.next({ type: 'info', message });
    this.clearAfterDelay();
  }

  private clearAfterDelay() {
    setTimeout(() => this.notificationSubject.next(null), 5000);
  }
    clear() {
    this.notificationSubject.next(null);
  }
}
